import { Injectable } from '@angular/core';
import { gql } from '@apollo/client';
import { Query } from 'apollo-angular';

import { ProductColorDetailsResponse } from '../models/product-color-details-response.model';
import { ProductColorDetailsVariables } from '../models/product-color-details-variables.model';

@Injectable({
  providedIn: 'root',
})
export class ProductColorDetailsQuery extends Query<ProductColorDetailsResponse, ProductColorDetailsVariables> {
  override document = gql`
    query (
      $productGroupId: String
      $colorCode: NonEmptyString!
      $colorPalette: NonEmptyString!
      $languageCode: NonEmptyString!
    ) {
      color(
        languageCode: $languageCode
        productColor: { productGroupId: $productGroupId, colorCode: $colorCode, paletteCode: $colorPalette }
      ) {
        code
        hex
        name
        paletteCode
        paletteName
        colorId
      }
    }
  `;
}
